import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SdvorLinkComponent } from '../link';

@Component({
  selector: 'sd-personal-data-agree-text',
  templateUrl: './personal-data-agree-text.component.html',
  styleUrls: ['./personal-data-agree-text.component.scss'],
  imports: [SdvorLinkComponent, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalDataAgreeTextComponent {}
